import { Component, Input, OnInit } from '@angular/core';
import { BrandingService } from '../../core/services/branding.service';

/**
 * Get Covered's privacy notice.
 *
 * Self-contained: the copy is markup in the template and the styling is in this
 * folder's stylesheet. It used to render ten translate keys through
 * [innerHTML], which forced its styles into the global assets/styles/pages/
 * tree — encapsulated component styles cannot reach injected HTML. The app
 * ships English only, so the indirection bought nothing and cost that.
 *
 * The page frame (card, width, padding) is on :host here rather than in the
 * eight-component static-page rule in styles.scss, because this is the only one
 * of those pages that needs room for a section index beside its prose.
 */
@Component({
    selector: 'app-privacy-policy-page',
    templateUrl: './privacy-policy-page.component.html',
    styleUrls: ['./privacy-policy-page.component.scss'],
    standalone: false
})
export class PrivacyPolicyPageComponent implements OnInit {
  /**
   * Suppressed by terms-privacy-modal: a sticky section index belongs on the
   * full-page route, not inside a dialog that owns its own scroll container.
   */
  @Input() showSectionNav = true;

  constructor(private brandingService: BrandingService) { }

  ngOnInit(): void {
    this.brandingService.setBrandingTitle('Privacy Policy');
  }
}
